import { render } from "./ArticleNavigation.vue?vue&type=template&id=bf9e35ac"
import script from "./ArticleNavigation.vue?vue&type=script&lang=js"
export * from "./ArticleNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__